import { datadogLogs } from '@datadog/browser-logs';
import { AccountOwner } from '../../../api';
import { Store, TeamMember } from '../../../interfaces';
import { getTeamMembersPrimaryStore } from '../team-member';

interface GetDefaultStoreSelectionProps {
  accountOwner: AccountOwner | undefined;
  broker: TeamMember | undefined;
}

type GetDefaultStoreSelection = (props: GetDefaultStoreSelectionProps) => Store | undefined;

export const getDefaultStore: GetDefaultStoreSelection = (props) => {
  const { broker, accountOwner } = props;

  const unableToReturnADefaultStore = !broker || !broker?.stores || !broker?.stores.length;

  if (unableToReturnADefaultStore) return undefined;

  /**
   * Account owner reads customer-workflow-event, contains customers store ID
   */
  const customerHasStore = accountOwner && accountOwner?.storeId;
  const fallbackStore = getTeamMembersPrimaryStore(broker) ?? (broker?.stores && broker?.stores[0]);

  if (!customerHasStore) {
    return fallbackStore;
  }

  const customersStoreDetails = broker?.stores && broker.stores.find((store) => store.id === accountOwner?.storeId);

  /**
   * This is an error case, however we fallback to the team members primary store to ensure failure gracefully.
   *
   * This realistically shouldn't be allowed to happen given Aussie franchisee / access rules.
   */
  if (!customersStoreDetails) {
    datadogLogs.logger.error(
      `A broker booking via myself flow does not contain the store data for the customers assigned store. CustomerID: ${accountOwner?.customerId}, storeID: ${accountOwner?.storeId}, brokerID: ${broker?.id}`
    );
  }

  return customersStoreDetails || fallbackStore;
};
